import { LocalStorageKeys } from "./index.js";

export function generateRandomId(initial) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let id = initial;
  for (let i = 0; i < 10; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return id;
}

const halfHour = 30 * 60 * 1000;
const nintyDays = 60 * 60 * 1000 * 24 * 90;

export function handleUpdateSession(callback) {
  const currentTime = Date.now();
  const key = LocalStorageKeys.SessionId;
  const storedData = localStorage.getItem(key);

  let sessionId;
  let didSessionUpdate = false;
  let isFirstMessageSent = false;

  if (storedData) {
    const { timestamp } = JSON.parse(storedData);
    sessionId = JSON.parse(storedData)?.sessionId;
    isFirstMessageSent = JSON.parse(storedData)?.isFirstMessageSent;

    if (currentTime - timestamp > halfHour) {
      sessionId = refreshKey(key, callback);
      didSessionUpdate = true;
      isFirstMessageSent = false;
    } else {
        updateSessionTimestamp(currentTime);
    }
  } else {
    sessionId = refreshKey(key, callback);
    didSessionUpdate = true;
    isFirstMessageSent = false;
  }

  return { sessionId, didSessionUpdate, isFirstMessageSent };
}

function refreshKey(key, callback) {
  const currentTime = Date.now();
  const sessionId = generateRandomId("session-");

  localStorage.setItem(
    key,
    JSON.stringify({
      timestamp: currentTime,
      sessionId,
      isFirstMessageSent: false
    })
  );

  if (typeof callback === "function") {
    callback();
  }

  return sessionId;
}

export function updateSessionTimestamp(value) {
    let currentValue = localStorage.getItem(LocalStorageKeys.SessionId);
    currentValue = JSON.parse(currentValue);

    const updatedValue = {...currentValue, timestamp: value};
    localStorage.setItem(LocalStorageKeys.SessionId, JSON.stringify(updatedValue));
}

export function updateIsFirstMessageSent(value) {
    let currentValue = localStorage.getItem(LocalStorageKeys.SessionId);
    currentValue = JSON.parse(currentValue);

    const updatedValue = {...currentValue, isFirstMessageSent: value};
    localStorage.setItem(LocalStorageKeys.SessionId, JSON.stringify(updatedValue));
}

export function handleUpdateUser() {
  const currentTime = Date.now();
  const key = LocalStorageKeys.UserId;
  const storedData = localStorage.getItem(key);

  let userId;
  let didUserUpdate = false;

  if (storedData) {
    const { timestamp } = JSON.parse(storedData);
    userId = JSON.parse(storedData)?.userId;

    if (currentTime - timestamp > nintyDays) {
      userId = refreshUserId(key);
      didUserUpdate = true;
    }
  } else {
    userId = refreshUserId(key);
    didUserUpdate = true;
  }

  return { userId, didUserUpdate };
}

function refreshUserId(key) {
  const currentTime = Date.now();
  const userId = generateRandomId("user-");

  localStorage.setItem(
    key,
    JSON.stringify({
      timestamp: currentTime,
      userId,
    })
  );

  return userId;
}
